
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import App from "./app/App";
import { Provider } from "react-redux";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import store from "app/redux/store";
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';

import "react-toastify/dist/ReactToastify.css";
import { USER_REQUEST } from "app/redux/actions/utilities";
import { ToastContainer } from "react-toastify";


try {
  const storedUser = localStorage.getItem('user');

  if (storedUser) {
    const user = JSON.parse(storedUser);

    store.dispatch({
      type: USER_REQUEST.LOGIN_SUCCESS,
      payload: user
    });
  }
} catch (error) {
  console.error("Could not re-hydrate user state from localStorage:", error);
  localStorage.removeItem('user');
}

const root = createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      {/* <BrowserRouter> */}
      <ToastContainer />
      <App />
    </BrowserRouter>
  </Provider>
);

serviceWorker.unregister();